import { render, staticRenderFns } from "./top-weather.vue?vue&type=template&id=2bd90fc2&scoped=true"
import script from "./top-weather.vue?vue&type=script&lang=js"
export * from "./top-weather.vue?vue&type=script&lang=js"
import style0 from "./top-weather.vue?vue&type=style&index=0&id=2bd90fc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd90fc2",
  null
  
)

export default component.exports